export type TNativeAudioWorkletNodeConstructor = typeof AudioWorkletNode;
